import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface AuditEntry {
  id: string; tenantId: string | null; actorId: string | null; actorKind: string
  action: string; resourceKind: string | null; resourceId: string | null
  metadata: unknown; ipAddress: string | null; userAgent: string | null
  createdAt: string
}

export function AdminAuditLogPage() {
  const t = useT()
  const [action, setAction] = useState('')

  const log = useQuery({
    queryKey: ['admin-audit-log', action],
    queryFn: () => {
      const params = new URLSearchParams()
      if (action) params.set('action', action)
      return apiClient.get<{ data: AuditEntry[] }>(`/admin/audit-log?${params}`)
    },
    refetchInterval: 30_000,
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('admin.audit.title')}</h1>
      <input
        value={action}
        onChange={(e) => setAction(e.target.value)}
        placeholder={t('admin.audit.filter')}
        className="px-2 py-1 text-sm border rounded bg-transparent w-64 mb-4"
        style={{ borderColor: 'var(--color-border)' }}
      />
      {log.isLoading && <p>{t('common.loading')}</p>}
      {log.data && (
        <ul className="space-y-2">
          {log.data.data.map((e) => (
            <li key={e.id} className="p-3 rounded border text-xs" style={{ borderColor: 'var(--color-border)' }}>
              <div className="flex items-center justify-between mb-1">
                <span className="font-mono font-medium">{e.action}</span>
                <span className="opacity-60">{new Date(e.createdAt).toLocaleString()}</span>
              </div>
              <div className="opacity-80 grid grid-cols-2 md:grid-cols-4 gap-2">
                <span>actor: {e.actorKind}{e.actorId ? ` (${e.actorId.slice(0, 8)}…)` : ''}</span>
                <span>tenant: {e.tenantId ? `${e.tenantId.slice(0, 8)}…` : '—'}</span>
                <span>resource: {e.resourceKind ?? '—'}</span>
                <span>ip: {e.ipAddress ?? '—'}</span>
              </div>
              {e.metadata && (
                <pre className="mt-2 text-[10px] opacity-60 overflow-auto">{JSON.stringify(e.metadata, null, 2)}</pre>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
